import React from 'react'
import PropTypes from 'prop-types'
import { Box, CardMedia } from '@mui/material'
import { DEEP_LINK } from '~/constants'
import { isIOS, isAndroid } from 'react-device-detect'

const styles = {
  wrapperBanner: {
    position: 'relative',
    width: '100%',
    paddingBottom: '55%',
  },
  innerBanner: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    borderRadius: '8px',
  },
}

const BannerPromote = ({ banner_promote_delivery }) => {
  const handleClickBanner = () => {
    if (!banner_promote_delivery || banner_promote_delivery?.length === 0) return
    const { deeplink_store_on_delivery } = banner_promote_delivery[0]
    if (deeplink_store_on_delivery) {
      window.location.href = deeplink_store_on_delivery
      return
    }
    if (isIOS) {
      window.location.replace(DEEP_LINK.APP)
      setTimeout(() => {
        window.location.replace(DEEP_LINK.APP_STORE)
      }, 10000)
    }
    if (isAndroid) {
      window.location.assign(DEEP_LINK.GOOGLE_PLAY)
    }
  }

  const renderBannerPromote = () => {
    if (!banner_promote_delivery || banner_promote_delivery?.length === 0) return null
    const { image } = banner_promote_delivery[0]
    return (
      <>
        <Box display="flex" justifyContent="center" marginTop="20px">
          <Box sx={styles.wrapperBanner}>
            <CardMedia
              onClick={handleClickBanner}
              loading="lazy"
              component="img"
              image={image}
              alt="banner"
              sx={styles.innerBanner}
            />
          </Box>
        </Box>
      </>
    )
  }

  return <>{renderBannerPromote()}</>
}

BannerPromote.propTypes = {
  banner_promote_delivery: PropTypes.array,
}

export default BannerPromote
